<template>
  <el-dialog width="600px" title="售后" v-model="isvisible">
    <el-descriptions :column="2">
      <el-descriptions-item label="申请时间">{{
        util.formatDateUnix(saleInfo.applyed, "yyyy-MM-dd hh:mm")
      }}</el-descriptions-item>
      <el-descriptions-item label="售后类型">{{
        util.showSaleType(saleInfo.saletype)
      }}</el-descriptions-item>
    </el-descriptions>
    <el-divider />
    <el-form
      ref="saleOptionFormRef"
      :model="saleOptionForm"
      :rules="rules"
      label-width="130px"
    >
      <el-form-item label="售后状态" prop="salestatus">
        <el-select
          v-model="saleOptionForm.salestatus"
          placeholder="请选择售后状态"
          style="width:100%"
        >
        <el-option label="未完成" :value="1" />
        <el-option label="已完成" :value="2" />
        <el-option label="已作废" :value="3" />
        </el-select>
      </el-form-item>
      <el-form-item label="供应商货款事宜" prop="supplieramount">
        <el-select
          v-model="saleOptionForm.supplieramount"
          placeholder="请选择供应商货款事宜"
          style="width:100%"
        >
          <el-option label="未修改" :value="6" />
          <el-option label="已打款抵扣余款" :value="1" />
          <el-option label="未打款" :value="2" />
          <el-option label="月结已付抵扣余款" :value="3" />
          <el-option label="已退款" :value="4" />
          <el-option label="未退款" :value="5" />
        </el-select>
      </el-form-item>
      <el-form-item label="售后说明" prop="salenote">
        <el-input
          type="textarea"
          autosize
          v-model.trim="saleOptionForm.salenote"
          placeholder="请输入售后说明"
        />
      </el-form-item>
    </el-form>

    <template #footer>
      <span class="dialog-footer">
        <el-button @click="closeDialog">关闭</el-button>
        <el-button type="danger" @click="doSaleOption" :loading="loading" >{{
          loading ? "提交中 ..." : "确认"
        }}</el-button>
      </span>
    </template>
  </el-dialog>
</template>
  <script setup>
import { ref, defineExpose, defineEmits } from "vue";
import { ElMessage } from "element-plus";
import { saveOrderSale } from "@/api/order/sale";

import util from "@/util/tool.js";


let timer;

const loading = ref(false);

const emit = defineEmits(["click"]); // 声明触发事件 change

const isvisible = ref(false);
const changeVisible = (v) => {
  isvisible.value = v;
};

const saleOptionFormRef = ref();
const saleOptionForm = ref({
  saleid:"",
  orderid: "",
  salestatus: "",
  supplieramount: "",
  salenote: "",
});

const saleInfo = ref({
  applyed: "",
  saletype: "",
  reason: "",
});
const saleMethod = (saleObj) => {
  saleInfo.value = {
    applyed: saleObj.applyed,
    saletype: saleObj.saletype,
    reason: saleObj.reason,
  };
  saleOptionForm.value = {
    orderid: saleObj.orderid,
    salestatus: saleObj.salestatus,
    supplieramount: saleObj.supplieramount,
    salenote: saleObj.salenote,
    saleid: saleObj.saleid,
  };
};

defineExpose({ changeVisible, saleMethod });

// const toEmits = () => {
//   //触发父组件中暴露的click方法并携带数据
//   isvisible.value = false;
//   console.log("isvisible--", isvisible.value);
//   emit("click", doSaleOption);
// };

const doSaleOption = () => {
  saleOptionFormRef.value.validate((valid) => {
    if (!valid) {
      //ElMessage("请先完善表单数据填写！");
      return;
    }
    saveOrderSale(saleOptionForm.value).then((res) => {
      loading.value = true;
      timer = setTimeout(() => {
        // 动画关闭需要一定的时间
        setTimeout(() => {
          loading.value = false;
        }, 400);
        if (res.data.code === 1) {
          closeDialog()
          emit('click')
        } else {
          ElMessage.error(res.data.msg)
        }
      }, 1000);
    });
  });
};

const closeDialog = () => {
  isvisible.value = false;
  saleOptionFormRef.value.resetFields();
  clearTimeout(timer);
};
//表单验证规则
const rules = ref({
  salestatus: [
    {
      required: true,
      message: "请选择售后状态",
      trigger: "change",
    }
  ],
  salenote: [
    {
      min: 2,
      max: 200,
      message: "售后说明长度2到200",
      trigger: "blur",
    },
  ],
});
</script>
  <style scoped>
.el-dialog {
  text-align: left;
}
.el-dialog__body {
  padding-top: 15px;
}
</style>